<template>
  <v-sheet color="transparent" min-width="300">
      <v-expand-transition>
    <v-form v-if="!checkEmail" @submit.prevent="resetPassword" ref="form" v-model="valid" lazy-validation>
        <div class="title primary--text mb-2 text-center">{{$t('resetPassword')}}</div>
      <v-text-field
        filled
        color="primary"
        class="white--text"
        v-model="credentials.email"
        :rules="emailRules()"
        v-bind:label="$t('loginEmail')"
        required
      ></v-text-field>
      <v-text-field
        dense
        outlined
        color="primary"
        class="d-none"
        id="website"
        v-model="credentials.honeypot"
        required
      ></v-text-field>
      <v-btn
        block
        x-large
        type="submit"
        color="primary"
        class="mb-3"
        :loading="loading"
        @click.prevent="resetPassword"
      >{{$t('resetPassword')}}</v-btn>
        <div class="mb-3 text-center">
      <a @click="$emit('login')">{{$t('login')}}</a>
      </div>
    </v-form>
    <div v-else>
        <div class="text-center black--text">
          <v-icon color="primary" x-large>fa-check-circle</v-icon>
          <p class="mt-4">{{$t('checkInbox')}}</p>

          <p class>{{$t('resetPasswordInstruction')}}</p>
        </div>
    </div>
    </v-expand-transition>
  </v-sheet>
</template>

<script>
import jwtdecode from "jwt-decode";
import sha256 from "sha256";
export default {
  name:"LoginComponent",
  beforeRouteEnter(to, from, next) {
    document.body.className = "login";
    if (from.name !== "Login" && from.name !== null) {
      localStorage.removeItem("auth");
      localStorage.removeItem("user");
    }
    next(vm => {
      // access to component instance via `vm`
      if (localStorage.getItem("auth") != null) {
        vm.$router.push({ name: "Projects" });
      } else {
        next();
      }
    });
  },

  // beforeRouteEnter(to, from, next) {},
  components: {},
  data: () => {
    return {
      loading: false,
      valid: false,
      credentials: {
        email: "",
        honeypot: ""
      },
      checkEmail: false,
    };
  },
  methods: {
    resetPassword() {
      if (this.valid && this.$refs.form.validate()) {
        if (this.credentials.honeypot.length == 0) {
          this.loading = true;
          
          this.$http
            .forgotPasswordChallenge(this.credentials.email)
            .then(res => {
                this.checkEmail = true;
                this.loading = false;
            })
            .catch(err => {
              this.$noty.error(this.$t("error"));
              console.log(err);
              this.loading = false;
            });
        }
      }
    },
    emailRules() {
      return [
        v => !!v || `${this.$t("email")} ${this.$t("required")}`,
        v => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(v) || `${this.$t("email")} ${this.$t("invalid")}`;
        }
      ];
    },
    passwordRules() {
      return [v => !!v || `${this.$t("password")} ${this.$t("required")}`];
    },
    encrypt() {
      this.credentials.password = sha256(this.credentials.inputP);
    }
  }
};
</script>


<style>
</style>


// WEBPACK FOOTER //
// src/components/Pages/Authentication/ForgotPassword.vue